export const language: any = {
  add_by_image: "Tambahkan melalui Gambar",
  add_image_by_camera: "Ambil Foto dengan Kamera",
  add_image_by_gallery: "Pilih Foto dari Galeri",
  loading: "Sedang menyiapkan resep lezat.\nMohon tunggu sebentar.",
  retry: "Coba Lagi",
  cancel: "Batal",
  yes: "Ya",
  no: "Tidak",
  goToIngredient: "Analisis bahan",
  goToRecipe: "Analisis resep",
  recipe: {
    title: "Resep AI",
    analysis_results: "Hasil Analisis",
    ingredients: {
      title: "Bahan (untuk 1 porsi)",
      view_more: 'Lihat {number} bahan lainnya',
      view_less: 'Tutup',
    },
    how_to_cook: "Cara Memasak",
    go_to_detail: "Lihat Resep AI",
    description: "Pengenalan Resep",
    calories: "Kalori",
    time: "Waktu Memasak",
    ingredient: "Bahan Utama",
    spice: "Bumbu",
    tip: "TIP",
  },
  ingredient: {
    title: "Analisis Gambar",
    analysis_results: "Hasil analisis bahan dari gambar adalah:",
    add_to_cart: "Tambah ke Keranjang",
    add_to_my_ingredients: "Tambah ke Bahan Saya",
  },
  msg: {
    not_ingredients: `Ini adalah foto yang bagus,\ntapi tempat ini khusus untuk bahan masakan!\nLain kali, unggah foto bahan makanan,\nrahasia memasak sedang menanti!\nPindah ke AI Chef sekarang?`,
    // AC-01-MSG-01
    not_recipes: `Hmm, ini bukan gambar masakan!\nKami hanya dapat menganalisis foto masakan.\nHarap unggah foto hidangan yang sudah selesai.\nMau pindah ke analisis bahan?`,
    not_found: "Tidak Ditemukan",
    unknow: `Sepertinya ini bukan foto masakan atau bahan makanan.\nJika Anda mengunggah foto masakan atau bahan makanan untuk analisis,\nkami dapat membantu Anda dengan lebih baik!`,
    upload_fail: `Gagal mengunggah karena kesalahan sementara.\nSilakan coba lagi nanti.`,
    error: `Ups! Analisis foto gagal.\nCoba pilih foto lain atau\ngunakan foto yang lebih jelas.`,
    bothType: `Foto ini mengandung bahan dan masakan!\nPilih apa yang ingin Anda analisis dari foto ini.`,
  },
}
